export interface IPropertyType {
  name: string;
  propertyTypeId: number;
  buildoutPropertyTypeId: null | number;
  netSuiteProductTypeId: null | number;
}

export const PropertyTypeImplementation = {
  getDefault(): IPropertyType {
    return {
      name: '',
      propertyTypeId: 0,
      buildoutPropertyTypeId: null,
      netSuiteProductTypeId: null,
    };
  },
};
